import type { SaunaHistoryResponse } from '@jums-dashboard/shared';
import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/app/auth';
import { getSaunaHistory } from '../services/saunaService';

const STALE_TIME_MS = 60_000;
const REFETCH_INTERVAL_MS = 60_000;

export const saunaHistoryQueryKey = (homeId: string | undefined, days: number) =>
  ['homeAutomation', 'saunaHistory', homeId ?? null, days] as const;

export default function useSaunaHistory(homeId: string | undefined, days: number, enabled: boolean) {
  const { status } = useAuth();
  const gate = status === 'authorized' && !!homeId && enabled;

  return useQuery<SaunaHistoryResponse>({
    queryKey: saunaHistoryQueryKey(homeId, days),
    queryFn: () => getSaunaHistory(homeId!, days),
    enabled: gate,
    staleTime: STALE_TIME_MS,
    refetchInterval: gate ? REFETCH_INTERVAL_MS : false,
  });
}
